import { type Extension, RangeSetBuilder } from "@codemirror/state";
import { Decoration, type DecorationSet, type EditorView, ViewPlugin, type ViewUpdate } from "@codemirror/view";
import { readRegEx } from "../regex";




const readLine = Decoration.line({
  attributes: { class: "qp-read-text" },
});

function readDeco(view: EditorView) {
  const builder = new RangeSetBuilder<Decoration>();
  for (const { from, to } of view.visibleRanges) {
    for (let pos = from; pos <= to;) {
      const line = view.state.doc.lineAt(pos);
      const modMatch = readRegEx.test(line.text);
      if (modMatch) {
        builder.add(line.from, line.from, readLine);
      }

      pos = line.to + 1;
    }
  }

  return builder.finish();
}

const showReadLines = ViewPlugin.fromClass(
  class {
    decorations: DecorationSet;

    constructor(view: EditorView) {
      this.decorations = readDeco(view);
    }

    update(update: ViewUpdate) {
      if (update.docChanged || update.viewportChanged) {
        this.decorations = readDeco(update.view);
      }
    }
  },
  {
    decorations: v => v.decorations,
  },
);

export function markReadLines(): Extension {
  return [
    showReadLines,
  ];
}
